import chroma from 'chroma-js'

const HSL_RANGE = {
  h: [0, 360],
  s: [50, 75],
  l: [25, 60],
}

/**
 * Generates a positive numerical hash based on Java's hashCode.
 */
const hashCode = (str: string): number =>
  str
    .split('')
    .reduce((hash, cur) => ((hash << 5) - hash + cur.charCodeAt(0)) | 0, 0) +
  Math.pow(2, 31)

/**
 * Normalizes a hashcode to a given range, useful for limiting colors.
 */
const normalizeHash = (hash: number, min: number, max: number) =>
  Math.floor((hash % (max - min)) + min)

/**
 * Returns a consistent, unique hex color for the given name.
 */
export const getCursorColor = (fullName: string): string => {
  const hash = hashCode(fullName)
  const h = normalizeHash(hash, HSL_RANGE.h[0], HSL_RANGE.h[1])
  const s = normalizeHash(hash, HSL_RANGE.s[0], HSL_RANGE.s[1])
  const l = normalizeHash(hash, HSL_RANGE.l[0], HSL_RANGE.l[1])
  return chroma.hsl(h, s, l).hex()
}
